<template>
  <div class="ds-progress-bar">
    <label
      v-if="Boolean(label)"
      for="ds-progress-bar"
      class="ds-progress-bar__label"
    >
      {{ label }}
    </label>
    <div class="ds-progress-bar__chart" ds-component="DsProgressBar">
      <div :class="progressBarClass" :style="percentageWidth" />
    </div>
    <span class="ds-progress-bar__percentage" v-if="showPercentage">
      {{ currentPercentage }}%
    </span>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from 'vue';

export default Vue.extend({
  name: 'DsProgressBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: 'icon-highlight'
    },
    label: {
      type: String,
      default: ''
    },
    showPercentage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    percentageWidth() {
      const percentage = this.currentPercentage;
      const width = this.value > this.max ? 100 : percentage;
      return {
        width: `${width}%`
      };
    },
    currentPercentage() {
      const percentage = 100 * (this.value / this.max);
      return Number(Math.round(percentage).toFixed(2));
    },
    progressBarClass() {
      return [
        'ds-progress-bar__progress',
        `ds-progress-bar__progress-${this.color}`
      ];
    }
  },
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/ProgressBar.scss';
</style>
